import React from 'react';
import { useSharedData } from '../Contexts/SharedContext';

import Logo from '../Elements/Icon/assets/logo.component.svg';

const Loader = () => {
    const { content, loading, error } = useSharedData();

    if (content && !loading) {
        return null;
    }

    return (
        <div className="loader">
            <div className="loader__logo">
                <Logo />
            </div>
            <span className="loader__loader"></span>
        </div>
    );
}

export default Loader;